import { render, staticRenderFns } from "./AllList.vue?vue&type=template&id=81a7f61c&scoped=true"
import script from "./AllList.vue?vue&type=script&lang=js"
export * from "./AllList.vue?vue&type=script&lang=js"
import style0 from "./AllList.vue?vue&type=style&index=0&id=81a7f61c&prod&lang=scss&scoped=true"
import style1 from "./AllList.vue?vue&type=style&index=1&id=81a7f61c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81a7f61c",
  null
  
)

export default component.exports